// ----------------------------------------------------------------------

const users = [
  {
    firstName: 'Admin',
    lastName: 'User',
    username: 'admin',
    password: 'lifelineadmin',
    role: 'admin',
    photoURL: '/static/mock-images/avatars/avatar_default.jpg',
  },
  {
    firstName: 'Operator',
    lastName: 'User',
    username: 'operator',
    password: 'lifelineoperator',
    role: 'operator',
    photoURL: '/static/mock-images/avatars/avatar_default.jpg',
  }
]


export default users;
